'use client';

import React from 'react';
import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';
import Image from 'next/image';
import { signOut, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { cn } from '@/helpers/common';
import HeaderDropdownMC from './HeaderDropdownMC';

const desktopLinkCn =
  'px-2 py-1 text-sm font-medium text-mc-santas-gray no-underline default-transition hover:text-mc-wattle';

const HeaderMC = () => {
  const pathname = usePathname();
  const { data: value } = useSession();
  const session = value;

  return (
    <header className="flex md:px-10 max-md:px-4 min-h-20 border-b border-mc-tuna bg-mc-shark">
      <div className="max-w-300 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
        <Link href={ROUTES.home} aria-label="McCarthy Search home">
          <Image
            width="174"
            height="20"
            src="https://assets.mccarthysearch.com/mccarthy/mc-logo.png"
            alt="McCarthy Search"
            unoptimized
            priority
          />
        </Link>
        <nav aria-label="Main" className="md:flex max-md:hidden items-center gap-4">
          <a
            aria-current={pathname === ROUTES.jobs ? 'page' : undefined}
            className={cn(desktopLinkCn, { 'text-mc-wattle': pathname === ROUTES.jobs })}
            href={ROUTES.jobs}
          >
            Jobs
          </a>
          {session && (
            <a
              aria-current={pathname === ROUTES.profile ? 'page' : undefined}
              className={cn(desktopLinkCn, {
                'text-mc-wattle': pathname === ROUTES.profile || pathname === ROUTES.history,
              })}
              href={ROUTES.profile}
            >
              Match profile
            </a>
          )}
          <a
            aria-current={pathname === ROUTES.partners ? 'page' : undefined}
            className={cn(desktopLinkCn, { 'text-mc-wattle': pathname === ROUTES.partners })}
            href={ROUTES.partners}
          >
            For employers
          </a>
          <div className="w-px h-4 bg-mc-2shark" />
          {session ? (
            <>
              <button className={desktopLinkCn} onClick={() => signOut()}>
                Sign out
              </button>
            </>
          ) : (
            <a
              className={
                'py-2 px-3 text-sm text-mc-woodsmoke font-bold bg-mc-wattle rounded-sm hover:bg-mc-buttered-rum default-transition'
              }
              href={ROUTES.signup}
            >
              Get matched
            </a>
          )}
        </nav>
        <div className="md:hidden max-md:block">
          <HeaderDropdownMC session={session} isSighInPath={pathname === ROUTES.signin} />
        </div>
      </div>
    </header>
  );
};

export default HeaderMC;
